window.addEventListener("OpusCartChange", (event) => {
  const targetElement = document.querySelector('.cd-bottom-button-group');

  if (targetElement) {
    // Check xem ảnh đã tồn tại chưa (trên toàn trang)
    let img = document.querySelector('.opus-banner-img');

    if (!img) {
      // Tạo ảnh nếu chưa có
      img = document.createElement('img');
      img.src = 'https://cdn.shopify.com/s/files/1/0677/8467/1279/files/image_lamaison.client_1.png?v=1743860640';
      img.className = 'opus-banner-img';
      img.style.width = '100%';

      // Chèn thử vào trước target
      targetElement.parentNode.insertBefore(img, targetElement);
    }

    // Đảm bảo nó đúng vị trí (trước target)
    setInterval(() => {
      const correct = targetElement.previousElementSibling === img;

      if (!correct) {
        // Nếu sai vị trí, di chuyển lại cho đúng
        targetElement.parentNode.insertBefore(img, targetElement);
      }
    }, 500); // Delay nhẹ để theme/scripts khác load xong
  }
});